import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class ShortedordersService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastShortedOrders").subscribe(
      (result: any) => {
        console.log("broadcastShortedOrders", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.customizeChartOptions('',true);
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Report_Periods = [];
            let xAxisData:string[] = [];
            let wsShortedQuantity = [];
            let psShortedQuantity = [];
            let sumShortedQuantity = [];
            let setting = widget.widgetsettings;
            
            let sorted_result = [];
            sorted_result = result.sort( (a:any, b:any) => {
              let aDt = new Date(a.REPORT_DATE);
              let bDt = new Date(b.REPORT_DATE);
              return bDt > aDt ? -1 : 1;
            });
            sorted_result.forEach(element => {
              let rptdate = "";
              rptdate = element.REPORT_DATE;
              if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                Report_Periods.push(rptdate);
                xAxisData.push(this._commonService.formatDate(new Date(rptdate),appSettings.chartDayFormat))
              }
            });

            Report_Periods.forEach(element => {
              result.find(item => {
                if((item.REPORT_DATE == element)&&(item.SHIP_TO_COUNTRY == setting.PickType)){
                  let xAxisDate = this._commonService.formatDate(new Date(element),appSettings.chartDayFormat);
                  let psValue = result.find(x=>(x.REPORT_DATE == element)&&(x.SHIP_TO_COUNTRY == setting.PickType) && (x.SHORT_TYPE.trim() == appSettings.PickShorts));
                  let psQty = 0;
                  if (psValue != null)
                  {
                    psQty = psValue.ORIGINAL_QUANTITY;
                  }
                  let wsValue = result.find(x=>(x.REPORT_DATE == element)&&(x.SHIP_TO_COUNTRY == setting.PickType) && (x.SHORT_TYPE.trim() == appSettings.WaveShorts));
                  let wsQty = 0;
                  if (wsValue != null)
                  {
                    wsQty = wsValue.ORIGINAL_QUANTITY;
                  }
                  let totalQty = psQty + wsQty;
                  if (item.SHORT_TYPE.trim() == appSettings.PickShorts){
                    if (totalQty>0)
                    {
                      let pShortedQty = Number(((item.SHORTED_QUANTITY / totalQty) * 100).toFixed(2));                     
                      psShortedQuantity.push([xAxisDate, pShortedQty, 'Pick Shorted Qty:' + item.SHORTED_QUANTITY, 'Original Qty:' + psQty ]);
                    }
                    else
                    {
                      psShortedQuantity.push([xAxisDate, 0, 'Pick Shorted Qty: 0', 'Original Qty: 0' ]);
                    }                    
                  }
                  else if(item.SHORT_TYPE.trim() == appSettings.WaveShorts){                    
                    if (totalQty>0)
                    {
                      let wShortedQty = Number(((item.SHORTED_QUANTITY / totalQty) * 100).toFixed(2));                     
                      wsShortedQuantity.push([xAxisDate, wShortedQty, 'Wave Shorted Qty:' + item.SHORTED_QUANTITY, 'Original Qty:' + wsQty ]);
                    }
                    else
                    {
                      wsShortedQuantity.push([xAxisDate, 0, 'Pick Shorted Qty: 0', 'Original Qty: 0' ]);
                    }       
                  }  
                }
              });
            });

            //for(let i=0;i<wsShortedQuantity.length;i++){
              //sumShortedQuantity[i]= psShortedQuantity[i] + wsShortedQuantity[i];
            //}
            xAxisData = [];
            Report_Periods.forEach(element => {
              let rptdate = "";
              rptdate = element;
                xAxisData.push(this._commonService.formatDate(new Date(rptdate),appSettings.chartDayFormat));
            });

            let yAxis = {
              name: 'Wave Shorts',
              nameLocation: 'center',
              nameGap: 50,
              min: '0',
              //max: '10',
              type: 'value',
              axisLabel: {
                interval: 0,
                length: "100%",
                color: "#fff",
                formatter: function(value){
                  let v:string = '';
                  v = value.toString();
                    v = v + '%';
                  return v;
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              },
              splitLine: {
                show: false
              }
            }
            // widget.chartOptions.yAxis.push(yAxis);
                        
            this.addDataSeries(widget.chartOptions, psShortedQuantity, 'Pick Shorts-Shorted Quantity', 'line');                        
            this.addDataSeries(widget.chartOptions, wsShortedQuantity, 'Wave Shorts-Shorted Quantity', 'line');
            //this.addDataSeriesDimension(widget.chartOptions, sumShortedQuantity, 'Total Shorts-Shorted Quantity', 'line');

            this.addZoomBar(widget.chartOptions);
            //Sorting
            //let rptDate = xAxisData.sort(function (a, b) { return a < b ? -1 : 1; }).reverse();
            widget.chartOptions.xAxis.data = xAxisData;// Report_Periods; // rptDate;
            widget.chartOptions.tooltip.formatter = this.tooltipShortedFormater;
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
          }
        }
        // console.log('widget options:',widget.chartOptions);
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("listenFor broadcastShortedOrders error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/shortedorders.service.ts